document.addEventListener('DOMContentLoaded', (event) => {
  const modal = document.getElementById('modal_main');
  if (modal) {
      const delay = modal.dataset.delay || 3000;
      setTimeout(() => {
          if (!document.cookie.split('; ').find(row => row.startsWith('modal_closed='))) {
              modal.classList.add('is--opened');
          }
      }, delay);
  }
});

// Función para cerrar el modal y establecer una cookie
function cerrarModal() {
  const modal = document.getElementById('modal_main');
  if (modal) {
      modal.classList.remove('is--opened');
  }
  document.cookie = "modal_closed=true; max-age=86400; path=/";
}

// Esperar a que el contenido del DOM esté completamente cargado
document.addEventListener('DOMContentLoaded', () => {
  const modalClose = document.getElementById('modal_close');
  if (modalClose) {
      modalClose.addEventListener('click', cerrarModal);
  }

  const modalBackdrop = document.querySelector('.modal__backdrop');
  if (modalBackdrop) {
      modalBackdrop.addEventListener('click', cerrarModal);
  }

  const modalBtn = document.querySelector('.modal__btn');
  if (modalBtn) {
      modalBtn.addEventListener('click', cerrarModal);
  }
});
